/* eslint-env node */

import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import api from './middleware/api';
import reducers from './reducers';

const createMiddleWare = config => {
  if (process.env.NODE_ENV === 'development') {
    let composeEnhancers =
      typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
        : compose;
    return composeEnhancers(applyMiddleware(thunk, api(config)));
  } else {
    return applyMiddleware(thunk, api(config));
  }
};

export default (initialState = {}, config = {}) => {
  let middleware = createMiddleWare(config);
  const store = createStore(reducers, initialState, middleware);
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers);
    });
  }
  return store;
};
